import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SecurityPolicy } from '../models/security-policy';
import { EnumReasonResetPassword } from '../models/enum-reason-reset-password';
import { EnumModeResetPassword } from '../models/enum-mode-reset-password';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class SecurityPolicyService extends ServiceBase {
    constructor(private http: HttpClient) {
        super();
    }

    GetSecurityPolicy(userId: string = null, globalNotification = true): Observable<SecurityPolicy> {
        const httpOptions = {
            params: new HttpParams().set('userId', userId),
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('global-notification', String(globalNotification)),
        };

        return this.http.get<SecurityPolicy>(`${this.baseUrl}/api/securityPolicy`, httpOptions);
    }

    StartPasswordReset(
        userId: string,
        reason: EnumReasonResetPassword,
        mode: EnumModeResetPassword,
        inputUrl: string,
        timeout: number = null,
        globalNotification = true
    ): Observable<string | null> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('global-notification', String(globalNotification)),
            params: new HttpParams().set('reason', reason).set('mode', mode).set('inputUrl', inputUrl).set('timeout', timeout),
        };

        return this.http.post<string>(`${this.baseUrl}/api/users/${userId}/resetPassword`, null, httpOptions);
    }

    FinishResetPassword(userId: string, securityCode: string, newPassword: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json'),
        };

        return this.http.post<string>(`${this.baseUrl}/api/users/${userId}/resetPassword/${securityCode}`, `\"${encodeURI(newPassword)}\"`, httpOptions);
    }

    GetUserIdByLogin(login: string): Observable<string | null> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('global-notification', 'false'),
        };

        return this.http.get<string>(`${this.baseUrl}/api/users/${login}/userId`, httpOptions);
    }
}
